<header class="top-bar">
  <div class="top-bar-content">
    <nav class="logo">
      <a routerLink="/">
        <img src="assets/images/mynteLogo.svg" alt="Mynte" />
      </a>
    </nav>

    <nav class="actions">
      @if (signedInUser()) {
        <small class="menu-item signed-in-user">{{ 'topBar.signedInUser' | translate }} {{ signedInUser() }}</small>
      }
      @if (showManage()) {
        <a class="menu-item pointer" (click)="openManager()">
          <span class="material-symbols-outlined"> manage_accounts </span>
          <p>{{ 'access.manage' | translate }}</p>
        </a>
      }
      <a class="menu-item pointer" (click)="logout()">
        <span class="material-symbols-outlined"> logout </span>
        <p>{{ 'topBar.logout' | translate }}</p>
      </a>
    </nav>
  </div>
</header>
